import styled from 'styled-components';

const NoMatchArea = styled.h2`
  margin: auto auto;
  width: 100vw;
`;

export const NoMatch = () => {
  return <NoMatchArea>存在しないページです</NoMatchArea>;
};
